import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditSpecializations = () => {
  return (
    <Edit title="Редактиране" mutationMode="pessimistic" actions={<BackButtonToolbar />}>
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditSpecializations;
